module.exports = __webpack_public_path__ + "media/115.d596eaa3.mp3";